import React from "react";

const MainEEgg = props => {

  const lang = document.documentElement.lang === "it"

    return (
        <section className="full-height bg-easter-egg position-relative">
            <div className="container-fluid full-height">
              <div className="row full-height d-flex align-items-center">
                <div className="col-md-7 m-auto">
                  <div className="p-sm-5 py-5 px-3 text-center bg-white" /*style={{ boxShadow: "0px 5px 60px #000" }}*/>
                    <div className="m-sm-4">
                      <h1 className="text-color mb-4 pb-md-2 text-start text-md-center">{lang ? "Sostenibilità, un viaggio lungo 10 anni" : "Sustainability, a 10-year journey"}</h1>
                      <p className="text-start mb-5">
                          {
                            lang ?
                              "Nel 2023 il Calendario Lavazza festeggia il suo trentesimo anniversario e celebra i 10 anni dedicati ai temi della sostenibilità. Per ripercorrere alcune tappe di questo viaggio, negli scatti fotografici di quest'anno sono stati nascosti 6 easter egg ispirati ai calendari dell'ultimo decennio: inizia l'experience e divertiti a trovarli."
                              : "In 2023, the Lavazza Calendar celebrates its 30th anniversary and pays homage to 10 years dedicated to sustainability issues. To retrace some stages of this journey, six Easter eggs inspired by the last decade’s Calendars have been hidden in this year’s shots: start the experience and have fun finding them. "
                          }
                      </p>
                      <button onClick={props.startHandler} className="btn btn-outline-dark btn-lg btn-lavazza">{lang ? "TROVA GLI EASTER EGG " : "FIND THE EASTER EGG "} 
                        <svg className="" xmlns="http://www.w3.org/2000/svg" width="4" height="8" viewBox="0 0 4 8">
                          <path id="Poligono_2" data-name="Poligono 2" d="M4,0,8,4H0Z" transform="translate(4) rotate(90)" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </section>
    )
}

export default MainEEgg